import {
  Box,
  ButtonLink,
  ButtonProps,
  Card,
  CenteredLoader,
  Flex,
  InfoIconWithTooltip,
  Separator,
  SubTitle,
  Text,
} from "@shared/primitive-components"
import { useCallback } from "react"
import { Lozenge, Stat, StatFeedback } from ".."
import { rebatesStyles as styles } from "../../styles"
import { FeedbackProps } from "../../types"

export const MILAGE_SUMMARY_DTI = {
  STAT: `mileage_summary_stat`,
  LABEL: `mileage_summary_label_stat`,
  FEEDBACK_ICON: `mileage_summary_feedback_icon`,
  FEEDBACK_TEXT: `mileage_summary_feedback_text`,
}

export type StatCardProps = {
  button: ButtonProps & {
    action: () => void
    text: string
  }
  feedback: FeedbackProps
  stat: string
  statLabel: string
  lowercaseLabel?: boolean
  target: string
  title: string
  tooltipText: string
  dataTestIds?: {
    learnMore?: string
    stat?: string
    label?: string
    feedback?: {
      icon?: string
      text?: string
    }
  }
  providerLoading?: boolean
}

export const StatCard = ({
  button,
  feedback,
  stat,
  statLabel,
  lowercaseLabel,
  target,
  title,
  tooltipText,
  dataTestIds,
  providerLoading,
}: StatCardProps) => {
  const TooltipContent = useCallback(
    () => (
      <Box>
        <Text css={styles.tooltipHeadingStyle}>{title}</Text>
        <Text css={styles.tooltipContent}>{tooltipText}</Text>
      </Box>
    ),
    [title, tooltipText]
  )

  return (
    <Card css={styles.cardWrap}>
      <Box css={styles.boxWrap}>
        <Flex alignItems="center">
          <SubTitle css={styles.statCardTitle}>{title}</SubTitle>
          <InfoIconWithTooltip content={TooltipContent} />
        </Flex>
        <Separator size="block" color="yellow" css={styles.marginBottom(6)} />

        {providerLoading ? (
          <CenteredLoader />
        ) : (
          <>
            <Box css={styles.marginBottom(4)}>
              <Stat
                stat={stat}
                statLabel={statLabel}
                lowercaseLabel={lowercaseLabel}
                dataTestIds={{ stat: dataTestIds?.stat, label: dataTestIds?.label }}
              />
            </Box>
            <Box>
              {!providerLoading && target && <Lozenge title={target} />}
              <StatFeedback feedback={feedback} dataTestIds={dataTestIds?.feedback} />
            </Box>
            <ButtonLink
              size="lg"
              display="block"
              data-testid={dataTestIds?.learnMore}
              onClick={button.action}
              css={styles.buttonLinkStyle}
            >
              {button.text}
            </ButtonLink>
          </>
        )}
      </Box>
    </Card>
  )
}

StatCard.defaultProps = {
  dataTestIds: undefined,
  lowercaseLabel: undefined,
  providerLoading: undefined,
}
